// Borders in nav and accordion
document.addEventListener("DOMContentLoaded", function() {
    function updateBorderStyles() {
        const sliderows = document.querySelectorAll('.sliderow');
        
        sliderows.forEach(sliderow => {
            const title = sliderow.querySelector('.sliderow__title');
            if (sliderow.classList.contains('is-hidden')) {
                title.style.borderBottom = 'none';
            } else {
                title.style.borderBottom = '1px solid var(--bss-grey)';
            }
        });
    }
    updateBorderStyles();
});


// Highlight Menu

document.addEventListener('DOMContentLoaded', function () {
    function removeEmptyMenuWrappers() {
        const menuWrappers = document.querySelectorAll('.mega__menu__buttons__wrapper');
        menuWrappers.forEach(wrapper => {
            const buttons = wrapper.querySelector('.mega__menu__buttons');
            if (!buttons || !buttons.innerHTML.trim()) {
                wrapper.remove();
                const parentRow = wrapper.closest('.sliderow__links');
                if (parentRow) {
                    parentRow.querySelectorAll('.sliderow__title').forEach(title => {
                        title.style.borderBottom = 'none';
                    });
                }
            }
        });
    }

    function applyStyles() {
        if (window.innerWidth > 768) { 
            removeEmptyMenuWrappers();
        }
    }

    applyStyles();

    window.addEventListener('resize', applyStyles);
});



// PDP swatches colors

document.addEventListener('DOMContentLoaded', function() {
    const showMoreButton = document.getElementById('show-more-swatches');
      if (localStorage.getItem('swatchesExpanded') === 'true') {
      expandSwatches();
    }
    
    if (showMoreButton) {
      showMoreButton.addEventListener('click', function() {
        expandSwatches();
        localStorage.setItem('swatchesExpanded', 'true');
      });
    }
    function expandSwatches() {
      const hiddenSwatches = document.querySelectorAll('.swatch--hidden');
      hiddenSwatches.forEach(function(swatch) {
        swatch.style.display = 'block';
      });
      if (showMoreButton) {
        showMoreButton.style.display = 'none';
      }
    }
  });

  // Menu 

  